import { FaUtensils } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const RED = "#B3231C";
const INK = "#1C1C1C";
const CREAM = "#F7F3EC";

const theme = {
  pageStyle: { backgroundColor: CREAM },
  headerClassName: "sticky top-0 z-20 bg-white shadow-sm",
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl hover:bg-black/5",
  titleClassName: "font-black",
  titleStyle: { color: INK },
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-bold text-white",
  badgeStyle: { backgroundColor: RED },
  cardClassName: "overflow-hidden rounded-2xl bg-white shadow-sm",
  PlaceholderIcon: FaUtensils,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl text-black/15 sm:aspect-[16/9]",
  placeholderStyle: { backgroundColor: "rgba(0,0,0,0.04)" },
  itemTitleClassName: "text-2xl font-black",
  itemTitleStyle: { color: INK },
  descriptionClassName: "mt-3 leading-7 text-black/60",
  priceStyle: { color: RED },
  stepperClassName: "flex items-center rounded-full bg-white shadow",
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold text-white shadow-lg",
  ctaStyle: { backgroundColor: RED },
};

const JapaneseMinimalFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default JapaneseMinimalFoodDetailTheme;
